import { createSlice } from '@reduxjs/toolkit';

import type { EscritorioConvitesState } from '@/types/escritorio/escritorioTypes';

import {
  aceitarConvite,
  buscarConvitePorToken,
  cancelarConvite,
  convidarMembro,
  listarConvites,
} from './actions';

const initialState: EscritorioConvitesState = {
  convites: [],
  isLoading: false,
  error: null,
};

const escritorioConvitesSlice = createSlice({
  name: 'escritorioConvites',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearConvites: (state) => {
      state.convites = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(convidarMembro.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(convidarMembro.fulfilled, (state, action) => {
        state.isLoading = false;
        state.convites.unshift(action.payload);
      })
      .addCase(convidarMembro.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(listarConvites.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarConvites.fulfilled, (state, action) => {
        state.isLoading = false;
        state.convites = action.payload;
      })
      .addCase(listarConvites.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(aceitarConvite.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(aceitarConvite.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(aceitarConvite.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(buscarConvitePorToken.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(buscarConvitePorToken.fulfilled, (state) => {
        state.isLoading = false;
        // Não adicionamos à lista de convites do administrativo
      })
      .addCase(buscarConvitePorToken.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(cancelarConvite.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(cancelarConvite.fulfilled, (state, action) => {
        state.isLoading = false;
        state.convites = state.convites.filter((c) => c.id !== action.payload);
      })
      .addCase(cancelarConvite.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export default escritorioConvitesSlice.reducer;
